import { SheetHeaderModal } from './sheet-header-modal';

/**
 * excel æä»¶è¯»åè¿åæ°æ®ç»æ
 */
export class SheetReadResult {
  /**
   * åæ°ç»
   */
  cols: Array<SheetHeaderModal>;

  /**
   * æ°æ®
   */
  xlsxData: Array<any>;

  constructor(cols: Array<SheetHeaderModal>, xlsxData: Array<any>) {
    this.cols = cols;
    this.xlsxData = xlsxData;
  }
}
